import { render, staticRenderFns } from "./Paneles.vue?vue&type=template&id=b286bc7e&scoped=true"
import script from "./Paneles.vue?vue&type=script&lang=js"
export * from "./Paneles.vue?vue&type=script&lang=js"
import style0 from "./Paneles.vue?vue&type=style&index=0&id=b286bc7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b286bc7e",
  null
  
)

export default component.exports